import { JobPostings } from '@platform/client';
import { DatePickerWithTimezone, Input, Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

interface CreateJobPostingModalProps {
  isOpen: boolean;
  onClose: () => void;
  resetPagination: () => void;
  limit: number;
}

export const CreateJobPostingModal = (props: CreateJobPostingModalProps) => {
  const { isOpen, onClose, resetPagination, limit } = props;

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [url, setUrl] = useState('');
  const [location, setLocation] = useState('');
  const [date, setDate] = useState(new Date());

  const queryClient = useQueryClient();

  const submitJobPosting = JobPostings.useCreateJobPosting({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [...JobPostings.getGetJobPostingsAdminQueryKey({ page: 0, limit })],
        });
        resetPagination();
      },
    },
  });

  const createJobPosting = async () => {
    submitJobPosting.mutate({
      data: {
        title,
        description,
        date: date.toISOString(),
        url,
        location,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
    setTitle('');
    setDescription('');
    setDate(new Date());
    setUrl('');
    setLocation('');
  };

  return (
    <Modal
      variant='dialog'
      title='Create Job Posting'
      isOpen={isOpen}
      headerDivision='divider'
      ignoreExtraPadding={true}
      onClose={closeModal}
      primaryCTA={{
        text: 'Create Job Posting',
        callback: createJobPosting,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          <Input
            label='Title'
            type='inline'
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <Input
            label='Description'
            type='multiline'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Input label='URL' type='inline' value={url} onChange={(e) => setUrl(e.target.value)} />
          <Input
            label='Location'
            type='inline'
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
          <DatePickerWithTimezone date={date} setDate={(newDate) => setDate(newDate)} />
        </div>
      </div>
    </Modal>
  );
};
